module.exports = __webpack_public_path__ + "static/dining1-07e236ee6bd7a7813a5b471ce8ca43a9.jpg";